<script>
export default {
  data() {
      return {
          widgetName: process.env.VUE_APP_WIDGET_NAME,
          widgetUrl: process.env.VUE_APP_WIDGET_URL,
          appName: process.env.VUE_APP_NAME,
          appUrl: process.env.VUE_APP_BRAND_URL,
          appTermsUrl: process.env.VUE_APP_BRAND_TERMS_URL,
          widgetDestination: process.env.VUE_APP_WIDGET_DESTINATION
      }
  },
}
</script>

<template>
  <div class="container mt20">
    <div class="row">
      <div class="col-sm-12 col-md-6">
        <h1 class="font-weight-bold mt-2 mb-3">{{ appName }} Widget</h1>
        <p>
          Add a useful public, shared and active transport planner to your website for free as part of the Tayside and Central Transport Partnership’s ‘ENABLE’ MaaS project. You can choose to have a locked location, such as a shop or hotel, as a set destination or a free-type text box which visitors to your site can enter any destination into.
        </p>
        <p>
          This page is for web developers looking to embed the {{ appName }} widget onto an existing website/webpage. Note that by including the {{ appName }} widget on your web site, you must agree to the <router-link class="white" :to="{name: 'TermsConditions'}">{{ appName }} widget terms and conditions</router-link>, as well as to the <a :href="appTermsUrl" target="_blank">terms and conditions for the {{ appName }}</a>.
        </p>
      </div>
      <div class="col-sm-12 col-md-6">
        <journey-planner-widget></journey-planner-widget>
      </div>
    </div>

    <div class="row">
      <div class="col-12">
        <h2 class="font-weight-bold mt-4 mt-md-0">Instructions</h2>
        <p>
          To include the widget on your website please add the following lines of code:<br />
          <br />
          inside <code class="inline-code">&#x3C;body&#x3E;&#x3C;/body&#x3E;</code> tag:

          <pre class="code-snippet">
&#x3C;{{ widgetName }}&#x3E;&#x3C;/{{ widgetName }}&#x3E;
&#x3C;script type=&#x22;text/javascript&#x22; src=&#x22;{{ widgetUrl }}/js/app.js&#x22;&#x3E;&#x3C;/script&#x3E;
          </pre>
        </p>
        <p>
          To lock the destination to a chosen address add <code class="inline-code">destination</code> attribute to the <code class="inline-code">&#x3C;{{ widgetName }}&#x3E;&#x3C;/{{ widgetName }}&#x3E;</code> tag:<br />

          <pre class="code-snippet">
            <span>&#x3C;{{ widgetName }} destination=&#x22;{{ widgetDestination }}&#x22;&#x3E;&#x3C;/{{ widgetName }}&#x3E;</span>
          </pre>
        </p>

        <h2 class="font-weight-bold mt-4">Example</h2>
        <!-- CODE -->
        <p class="mb-5">
          <pre class="code-snippet">
            &#x3C;!DOCTYPE html&#x3E;<br />
            &#x3C;html&#x3E;<br />
  &#x3C;head&#x3E;<br />
  &#x9;    &#x3C;meta charset=&#x22;utf-8&#x22;&#x3E;<br />
  &#x9;    &#x3C;title&#x3E;Your website title&#x3C;/title&#x3E;<br />
  &#x3C;/head&#x3E;<br />
  &#x3C;body&#x3E;<br />
  &#x9;    &#x3C;{{ widgetName }} destination=&#x22;{{ widgetDestination }}&#x22;&#x3E;&#x3C;/{{ widgetName }}&#x3E;<br />
  &#x9;    &#x3C;script type=&#x22;text/javascript&#x22; src=&#x22;{{ widgetUrl }}/js/app.js&#x22;&#x3E;&#x3C;/script&#x3E;<br />
  &#x3C;/body&#x3E;<br />
&#x3C;/html&#x3E;
          </pre>
        </p>
      </div>
    </div>
  </div>
</template>

<style scoped>
p {
  margin-bottom: 20px;
}
.container {
  margin-top: 20px;
}
</style>
